'use strict';

module.exports = require('string.prototype.padend');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.prototype.padEnd.js
// module id = 809
// module chunks = 0